export default __webpack_public_path__ + "static/media/cover.96ee64d4.webp";